<template>
    <div>
       <div class="kit__utils__heading">
         <!-- <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5> -->
       </div>
       <div class="card">
         <!-- <div class="card-header card-header-flex">
           <div class="d-flex flex-column justify-content-center mr-auto">
             <h5 class="mb-0"></h5>
           </div>
           <div class="d-flex flex-column justify-content-center">
           </div>
         </div> -->
         <div class="card-body">
           <div class="card-header card-header-flex">
             <div class="d-flex flex-column justify-content-center mr-auto">
               <h5 class="mb-0"></h5>
             </div>
             <div class="d-flex flex-column justify-content-center">
               <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                   class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
             </div>
           </div>
           <a-table :columns="columns" :dataSource="data" rowKey='id' :loading="loadingTable" :scroll="{ x: 1200 }">
               <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              class="custom-filter-dropdown"
            >
              <a-input
                v-ant-ref="c => searchInput = c"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm)"
                style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                type="primary"
                @click="() => handleSearch(selectedKeys, confirm)"
                size="small"
                style="width: 90px; margin-right: 8px"
              >Search</a-button>
              <a-button
                @click="() => handleReset(clearFilters)"
                size="small"
                style="width: 90px"
              >Reset</a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <h6 slot="status" slot-scope="status, record">
                <b-badge href="#" @click="useAction(record.id, status)" pill :variant="getStatus('callBack',status).color">
                {{getStatus('callBack',status).name}}
                </b-badge>
            </h6>
            <span slot="Action" slot-scope="text,record">
             <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item @click="showDrawer(record.callBackStatus,record.id)">รายละเอียด </a-menu-item>
              </a-menu>
            <a-button style="margin-left: 8px"> จัดการ <a-icon type="down" /> </a-button>
          </a-dropdown>
           </span>
           </a-table>
           <a-drawer
                title="รายละเอียด"
                width="520"
                :closable="false"
                :visible="visible"
                @close="onClose"
            >
            <a-form :form="form" layout="vertical" hide-required-mark>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="คู่ค้า">
              <a-input
              v-model="form.name"
              style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Table">
              <a-input
                v-model="form.orderTable"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="callBackURL">
              <a-input
              v-model="form.callBackURL"
              style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="num">
                <a-input
                v-model="form.num"
                style="width: 100%"
                />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="สถานะ" v-if="form.callBackStatus !== ''">
                <b-badge pill :variant="getStatus('callBack', form.callBackStatus).color">
                    {{getStatus('callBack', form.callBackStatus).name}}
                </b-badge>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="sendData">
              <a-textarea
                v-model="form.sendData"
                :rows="10"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onClose">
          Cancel
        </a-button>
      </div>
        </a-drawer>
         </div>
       </div>
    </div>
  </template>

<script>
import { mapGetters } from 'vuex'
import { getName } from '@/utils/status'
import apiClient from '@/services/api'
import Swal from 'sweetalert2'
// import moment from 'moment'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getSelectStatus: 'getSelectStatus',
      getKeyword: 'getKeyword',
    }),
  },
  watch: {
    getStartDate: function(val) {
      if (val) this.getData()
    },
    getEndDate: function(val) {
      if (val && !this.checkFistPage) {
        this.getData()
      }

      if (this.checkFistPage) this.checkFistPage = false
    },
    getSelectStatus: function(val) {
      if (val) this.getData()
    },
    getKeyword: function(val) {
      if (val) this.getData(val)
    },
  },
  data() {
    return {
      data: [],
      dataService: [],
      apiList: [],
      loadingTable: false,
      visible: false,
      childrenDrawer: false,
      checkFistPage: false,
      form: {
        name: '',
        orderTable: '',
        callBackURL: '',
        num: '',
        callBackStatus: '',
        sendData: '',
      },
      columns: [
        {
          title: 'ลำดับ',
          key: 'id',
          dataIndex: 'id',
          width: 120,
        },
        {
          title: 'คู่ค้า',
          key: 'name',
          dataIndex: 'name',
          filters: [],
          onFilter: (value, record) => record.name.toString().includes(value.toString()),
          width: 150,
        },
        {
          title: 'Table',
          key: 'orderTable',
          dataIndex: 'orderTable',
          sorter: (a, b) => a.orderTable - b.orderTable,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'orderTable',
          },
          onFilter: (value, record) => record.orderTable.toLowerCase().includes(value.toLowerCase()),
          width: 150,
        },
        {
          title: 'callBackURL',
          key: 'callBackURL',
          dataIndex: 'callBackURL',
          width: 220,
        },
        {
          title: 'num',
          key: 'num',
          dataIndex: 'num',
          width: 100,
        },
        {
          title: 'สถานะ',
          key: 'callBackStatus',
          dataIndex: 'callBackStatus',
          filters: [
            { text: 'สำเร็จ', value: '000' },
            { text: 'รอการส่ง', value: '001' },
            { text: 'ส่งแล้วรอตอบกลับ', value: '002' },
            { text: 'ไม่ได้รับการตอบกลับเกินจำนวนครั้ง', value: '003' },
          ],
          onFilter: (value, record) => record.callBackStatus.toString().includes(value.toString()),
          scopedSlots: {
            customRender: 'status',
          },
          width: 150,
        },
        {
          title: 'รายละเอียด',
          key: 'Action',
          dataIndex: 'id',
          scopedSlots: { customRender: 'Action' },
          width: 150,
        },
      ],
    }
  },
  methods: {
    async showDrawer(callBackStatus, callId) {
      await apiClient.get(`/callBack/${callId}`).then(response => {
        if (response.data.code === '000') {
          const resultData = response.data.responseData.data[0]
          this.visible = true
          this.form.name = resultData.name
          this.form.orderTable = resultData.orderTable
          this.form.callBackURL = resultData.callBackURL
          this.form.num = resultData.num
          this.form.callBackStatus = resultData.callBackStatus
          this.form.sendData = resultData.sendData
        }
      }).catch(error => {
        Swal.showValidationMessage(
             `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    onClose() {
      this.visible = false
    },
    showChildrenDrawer() {
      this.childrenDrawer = true
    },
    onChildrenDrawerClose() {
      this.childrenDrawer = false
    },
    useAction(callId, status) {
      if (status === '003') this.recheck(callId, status)
    },
    async recheck(callId, callBackStatus) {
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการเปลี่ยนสถานะรายการนี้',
        icon: 'question',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            const data = { callId: callId, callBackStatus: callBackStatus }
            return apiClient.post('/callBack/reStatusCode', data).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                `Request failed: ${error}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.getData()
        }
      })
    },
    async getData() {
      const dataStatement = {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        status: this.getSelectStatus,
        keyword: this.getKeyword,
      }
      this.loadingTable = true
      await apiClient.post('/callBack', dataStatement).then(response => {
        if (response.data.code === '000') {
          this.loadingTable = false
          this.data = response.data.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
             `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },

    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },

    refreshData() {
      this.loading(true)
      this.getData()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  async created() {
    await this.getData()
  },

}
</script>

  <style>

  </style>
